import React from "react";
import theme from "src/theme";
import styled from "styled-components";

import SocialNetworks from "../../../../../../../components/SocialNetworks";
import AboutSection from "../AboutSection";
import HelpSection from "../HelpSection";
import LegalNotice from "../LegalNotice";
import { Newsletter } from "../Newsletter";
import PaymentSection from "../PaymentSection";
import ReinsuranceSection from "../ReinsuranceSection";

const Separator = styled.div`
  border-top: 1px solid ${theme.colors.veryLightGrey};
  margin: ${theme.margins.marginBig};
`;

const FooterMobile = (): JSX.Element => (
  <div>
    <ReinsuranceSection />
    <HelpSection />
    <Newsletter />
    <SocialNetworks />
    <AboutSection />
    <PaymentSection />
    <Separator />
    <LegalNotice />
  </div>
);

export default FooterMobile;
